import { createUseStyles } from "react-jss";

import logoGray from "logo_gray.svg";

import SwiperCore, { EffectCoverflow, Autoplay } from "swiper";
import { Swiper, SwiperSlide } from "swiper/react";
// Import Swiper styles
import "swiper/swiper.min.css";
import "swiper/components/navigation/navigation.min.css";
import "swiper/components/pagination/pagination.min.css";
import "swiper/components/scrollbar/scrollbar.min.css";
import { FaMapMarkerAlt } from "react-icons/fa";
import NumberFormat from "react-number-format";
import { useEffect, useMemo, useRef, useState } from "react";
import { colors } from "helpers/colors";
import { IOffer } from "types/IOffer";
import {
  SIDE_SWIPER_SLIDES_PER_VIEW,
  SWIPER_DELAY,
  SWIPER_DURATION,
} from "helpers/const";
import {
  getBannerText,
  getCleanPhotoList,
  getContactPhone,
  getDescription,
  getDpeGes,
  getPriceDetails,
  getPropertyDetails,
} from "helpers/offer";

// install Swiper modules
SwiperCore.use([Autoplay, EffectCoverflow]);

const MAX_NUMBER_OF_DETAILS = 6;

interface IProps {
  offer: IOffer;
}

export default function Offer6(props: IProps) {
  const { offer } = props;

  const propertyDetails = useMemo(() => {
    return getPropertyDetails(offer, 20, MAX_NUMBER_OF_DETAILS);
  }, [offer]);

  const dpeGes = useMemo(() => {
    return getDpeGes(offer, 140, 75);
  }, [offer]);

  const priceDetails = useMemo(() => {
    return getPriceDetails(offer);
  }, [offer]);

  const banner = useMemo(() => {
    return getBannerText(offer);
  }, [offer]);

  const photos = useMemo(() => {
    // swiperJS bug if slides < slidesPerView https://github.com/nolimits4web/swiper/issues/3431
    return getCleanPhotoList(offer.photos, SIDE_SWIPER_SLIDES_PER_VIEW);
  }, [offer]);

  const description = useMemo(() => {
    return getDescription(offer);
  }, [offer]);

  const contactPhone = useMemo(() => {
    return getContactPhone(offer);
  }, [offer]);

  const [titleTranslate, setTitleTranslate] = useState(0);
  const titleDivRef = useRef<any>();
  useEffect(() => {
    if (titleDivRef.current) {
      const titleDiv = titleDivRef.current.parentElement;
      const h1 = titleDivRef.current;

      if (titleDiv && h1) {
        const parentWidth = titleDiv?.offsetWidth;
        const childWidth = h1?.offsetWidth;
        const diff = parentWidth - childWidth;
        if (diff < 0) {
          const translatePx = Math.abs(diff);
          setTitleTranslate(translatePx);
        }
      }
    }
  }, [titleDivRef, offer?.label]);

  const classes = useStyles({ theme: { titleTranslate } });
  return offer ? (
    <div className={classes.container}>
      <div className={classes.contentContainer}>
        <div className={classes.titleContainer}>
          <div>
            <h1 ref={titleDivRef}>{offer.label}</h1>
          </div>
          <div>
            <span>
              <NumberFormat
                value={offer.price}
                displayType={"text"}
                thousandSeparator={" "}
                suffix={" €"}
              />
            </span>
          </div>
        </div>
        <div className={classes.content}>
          <div className={classes.leftContainer}>
            <div className={classes.swiperWrapper}>
              <div className={classes.swiperContainer}>
                <Swiper
                  dir="rtl"
                  effect={"coverflow"}
                  slidesPerView={1}
                  loop={true}
                  autoplay={{
                    delay: SWIPER_DELAY,
                    disableOnInteraction: false,
                  }}
                  speed={SWIPER_DURATION}
                  freeMode={true}
                  freeModeMomentum={false}
                  freeModeMomentumBounce={false}
                  allowTouchMove={false}
                >
                  {photos.map((photo: any, index: number) => {
                    return (
                      <SwiperSlide key={`main-${index}`}>
                        <img
                          src={`https://tools.instore-solution.fr/api/resizeimage/1280/1280/${encodeURIComponent(
                            photo.file.path
                          )}`}
                          // src={photo.file.path}
                          alt=""
                        />
                      </SwiperSlide>
                    );
                  })}
                </Swiper>
                {banner && (
                  <div className={"banner"}>
                    <div dangerouslySetInnerHTML={{ __html: banner }}></div>
                  </div>
                )}
                <div className={"offer-type-container"}>{offer.offerType}</div>
              </div>
              <div className={classes.sideSwiperContainer}>
                <Swiper
                  direction={"horizontal"}
                  spaceBetween={5}
                  slidesPerView={4}
                  loop={true}
                  autoplay={{
                    delay: SWIPER_DELAY,
                    disableOnInteraction: false,
                  }}
                  speed={SWIPER_DURATION}
                  freeMode={true}
                  freeModeMomentum={false}
                  freeModeMomentumBounce={false}
                  allowTouchMove={false}
                >
                  {photos.map((photo: any, index: number) => {
                    return (
                      <SwiperSlide key={`main-${index}`}>
                        <img
                          src={`https://tools.instore-solution.fr/api/resizeimage/480/480/${encodeURIComponent(
                            photo.file.path
                          )}`}
                          // src={photo.file.path}
                          alt=""
                        />
                      </SwiperSlide>
                    );
                  })}
                </Swiper>
              </div>
            </div>
            <div className={classes.footerContainer}>
              <div className={classes.propertyDetailsContainer}>
                {propertyDetails}
              </div>
              <div>
                <div className={classes.priceDetailsContainer}>
                  <span
                    dangerouslySetInnerHTML={{ __html: priceDetails }}
                  ></span>
                </div>
                <div className={classes.descriptionFooterContainer}>
                  <div>Ref: {offer.reference}</div>
                  <img src={logoGray} alt="" />
                </div>
              </div>
            </div>
          </div>
          <div className={classes.descriptionContainer}>
            <div className={"description-title"}>
              <FaMapMarkerAlt />
              <h2>{offer.city}</h2>
            </div>
            <div
              className={classes.description}
              dangerouslySetInnerHTML={{ __html: description }}
            ></div>
            <div className={classes.descriptionBottomContainer}>
              <div className={classes.dpegesContainer}>{dpeGes}</div>
              <div>{contactPhone}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  ) : (
    <div></div>
  );
}

const useStyles = createUseStyles((theme: { titleTranslate: number }) => ({
  "@keyframes titleAnim1": {
    from: {
      transform: `translate3d(0, 0, 0)`,
    },
    to: {
      transform: `translate3d(-${theme.titleTranslate}px, 0, 0)`,
    },
  },
  container: {
    flex: 1,
    display: "flex",
    backgroundColor: "white",
    marginBottom: 10,
  },
  contentContainer: {
    flex: 1,
    display: "flex",
    flexDirection: "column",
  },
  titleContainer: {
    position: "relative",
    display: "flex",
    flexDirection: "row",
    alignContent: "center",
    alignItems: "center",
    "& > div:first-child": {
      width: 325,
      overflow: "hidden",
      textAlign: "center",
      "& > h1": {
        display: "inline-block",
        padding: "0 20px",
        fontWeight: 600,
        fontSize: 14,
        whiteSpace: "nowrap",
        animation: "$titleAnim1 5s linear 2s infinite alternate",
      },
      "& span:first-letter": {
        textTransform: "capitalize",
      },
    },
    "& > div:nth-child(2)": {
      padding: "20px 0",
      backgroundColor: colors.imko,
      color: "white",
      fontWeight: 600,
      fontSize: 20,
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      flex: 1,
      overflow: "hidden",
      "& > span": {
        whiteSpace: "nowrap",
        overflow: "hidden",
        textOverflow: "ellipsis",
      },
    },
  },
  content: {
    display: "flex",
    flex: 1,
    flexDirection: "row",
    overflow: "hidden",
  },
  leftContainer: {
    flex: 1,
    display: "flex",
    flexDirection: "column",
  },
  swiperWrapper: {
    display: "flex",
    flexDirection: "column",
  },
  swiperContainer: {
    position: "relative",
    width: 325,
    height: 180,
    "& .swiper-container": {
      height: "100%",
      "& .swiper-slide": {
        alignItems: "center",
        display: "flex",
        justifyContent: "center",
        "& img": {
          width: "100%",
          height: "100%",
          objectFit: "cover",
          "&.empty-slide": {
            width: "auto",
            height: "auto",
            objectFit: "none",
          },
        },
      },
    },
    "& .banner": {
      position: "absolute",
      top: 20,
      left: "-32%",
      width: "100%",
      backgroundColor: colors.imko + "CC",
      color: "white",
      fontSize: "20px",
      padding: "5px 0px",
      zIndex: 10,
      transform: "rotate(-35deg)",
      "& > div": {
        textAlign: "center",
        overflow: "hidden",
        // whiteSpace: "nowrap",
        // textOverflow: "ellipsis",
        wordBreak: "break-word",
        position: "relative",
        width: 95,
        margin: "0 auto",
      },
    },
    "& .offer-type-container": {
      position: "absolute",
      top: 0,
      right: 0,
      background: `${colors.imko}4C`,
      color: colors.white,
      fontWeight: 600,
      fontSize: 10,
      padding: "5px 10px",
      zIndex: 10,
    },
  },
  sideSwiperContainer: {
    paddingTop: 5,
    paddingBottom: 10,
    width: 325,
    height: 50,
    "& .swiper-container": {
      height: "100%",
      "& .swiper-slide": {
        alignItems: "center",
        display: "flex",
        justifyContent: "center",
        "& img": {
          width: "100%",
          height: "100%",
          objectFit: "cover",
          "&.empty-slide": {
            width: "auto",
            height: "auto",
            objectFit: "none",
          },
        },
      },
    },
  },
  descriptionContainer: {
    flex: 1,
    padding: "5px 10px",
    textAlign: "justify",
    fontSize: "13px",
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    overflow: "hidden",
    "& .description-title": {
      display: "flex",
      flexDirection: "row",
      alignContent: "center",
      justifyContent: "center",
      alignItems: "center",
      "& h2:first-letter": {
        textTransform: "capitalize",
      },
      "& h2": {
        margin: "10px",
      },
    },
  },
  descriptionBottomContainer: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-end",
  },
  description: {
    whiteSpace: "normal",
    overflow: "hidden",
    textOverflow: "ellipsis",
    display: "-webkit-box", //https://stackoverflow.com/a/41137262/5052969
    "-webkit-line-clamp": 22,
    "-webkit-box-orient": "vertical",
  },
  dpegesContainer: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-around",
  },
  priceDetailsContainer: {
    fontSize: 10,
  },
  footerContainer: {
    flex: 1,
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    padding: "0 10px",
    fontSize: "10px",
  },
  propertyDetailsContainer: {
    width: "100%",
    display: "flex",
    flexDirection: "row",
    flexWrap: "wrap",
    justifyContent: "flex-start",
    "& > div": {
      width: "33%",
      marginTop: 5,
      textAlign: "center",
      fontSize: "10px",
    },
  },
  descriptionFooterContainer: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "flex-end",
    paddingBottom: 5,
    "& img": {
      width: 100,
    },
  },
}));
